import axios from "axios";
import {reactive, toRefs} from "vue";

const state = reactive({
    init_id: window.init_account_id,
    provider: {},
    provider_found: false,
    loading: false,
    initialised: false,
    vas_feature_flag: window.vas_feature_flag,
});

let axios_interceptor = null;

export default function useActiveProviderStore()
{
    const check = async() => {
        if (!state.initialised && !state.loading) {
            await restoreState();
        }
        return !!state.provider_found;
    }

    const restoreState = async() => {
        state.loading = true;

        try {
            let account = (await axios.get('/public/accounts/'+state.init_id)).data.data;
            state.loading = false;
            state.initialised = true;

            if (account.type !== 'PROVIDER') {
                throw new Error('Invalid account');
            }
            state.provider = account;
            state.provider_found = true;
        } catch (error) {
            console.error('Failed to initialise account:', error)
        }
    }

    return {
        ...toRefs(state), // convert to refs when returning
        restoreState,
        check,
    }
}